import {TokenTransferTitleButton} from '#/components/wallet-transfer/wallet-transfer-modal';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

export const WalletTransferTokenInputGroup: FunctionComponent<{
  value: string;
  isAboveBalance: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onMaxAmountButtonClick: () => void;
  getInitialValue: () => string;
}> = ({value, isAboveBalance, onChange, onMaxAmountButtonClick, getInitialValue}) => {
  const {t} = useTranslation('translation');

  return (
    <div className='mt-0'>
      <div className='flex items-stretch gap-2 h-8'>
        <div
          className={`grow flex items-stretch px-2 py-1 gap-2 bg-gray-200 rounded-lg ${
            isAboveBalance ? 'ring-2 ring-downred' : ''
          }`}
        >
          <input
            className={'grow p-0 appearance-none bg-transparent outline-none'}
            onChange={onChange}
            value={value}
            type='number'
          />
        </div>

        <TokenTransferTitleButton
          className='bg-deepblue border border-deepblue text-white disabled:bg-transparent disabled:border-gray-400 disabled:text-gray-400 w-14'
          onClick={onMaxAmountButtonClick}
          disabled={getInitialValue() === value}
        >
          {t('actions.max')}
        </TokenTransferTitleButton>
      </div>
      {isAboveBalance && (
        <div className='text-downred text-xs font-bold italic mt-1'>
          {t('components.walletTransferTokenInputGroup.amountExceedsBalance')}
        </div>
      )}
    </div>
  );
};
